import React from 'react';
import { View, Text } from 'react-native';
import Feather from 'react-native-vector-icons/Feather';

const criteria = [
	{
		test: password => password?.length >= 8 && password?.length <= 24,
		message: '8 to 24 characters.',
	},
	{
		test: password =>
			/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%]).*/.test(password),
		message:
			'Must include uppercase and lowercase letters, a number, and a special character.',
	},
	{
		test: (password, confirmPassword) => password === confirmPassword,
		message: 'Passwords must match.',
	},
	// Add more criteria as necessary
];

const PasswordValidation = ({ password, confirmPassword }) => (
	<View
		style={{
			position: 'absolute',
			backgroundColor: 'orange',
			top: 40,
			zIndex: 10,
			right: 0,
			width: '100%',
		}}
	>
		{criteria.map((criterion, index) => (
			<Text key={index} style={{ color: 'black' }}>
				{criterion.message}{' '}
				<Feather
					name={criterion.test(password, confirmPassword) ? 'check' : 'x'}
					size={20}
					color={criterion.test(password, confirmPassword) ? 'green' : 'red'}
				/>
			</Text>
		))}
	</View>
);

export default PasswordValidation;
